import { SectionListQuery } from '__generated__/graphql/legacy/graphql';
import { canPostInReadOnlySpace } from 'utils/userHelpers';

import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { useCommunityContext } from 'components/CommunityContext';
import { FONTS } from 'components/FontProvider';

import { SECTION_QUERY } from 'schema/Section/queries';

interface SpaceOption {
  value: string;
  label: string;
  caption?: string;
  disabledStatus?: {
    reason: string;
    variant: string;
  };
  dangerousFontFamily?: string;
}

const useSpacesList = () => {
  const { community, currentUser } = useCommunityContext();
  const { data, loading: isSpacesListLoading } = useQuery<SectionListQuery>(SECTION_QUERY, {
    variables: { communityId: community.id },
  });

  const communitySectionsEdges = data?.community?.communitySections?.edges;

  let spacesList: SpaceOption[] = [];

  if (communitySectionsEdges && communitySectionsEdges[0]?.node?.communitySpaces?.edges) {
    const spaces = communitySectionsEdges[0]?.node?.communitySpaces?.edges?.map((edge) => {
      return {
        value: edge?.node?.id || '',
        label: edge?.node?.name || '',
        caption: edge?.node?.readOnly && canPostInReadOnlySpace(currentUser) ? 'Read only' : '',
        disabledStatus:
          edge?.node?.readOnly && !canPostInReadOnlySpace(currentUser)
            ? {
                reason: 'Read only',
                variant: 'neutral',
              }
            : undefined,
        dangerousFontFamily: `"${FONTS[community.font]}"`, // TODO: Remove this after Chalk fixes option theming
      };
    });
    spacesList = [...spacesList, ...spaces];
  }

  return {
    spacesList,
    firstPostableSpace: useMemo(
      () => spacesList.find((space) => !space.disabledStatus) || null,
      [spacesList]
    ),
    isSpacesListLoading,
  };
};

export default useSpacesList;
